import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { cateringMenu } from '../data/menuData';
import './Catering.css';

const Catering = () => {
  return (
    <div className="catering-page">
      <Navigation />
      <div className="catering-content">
        <div className="catering-header">
          <Link to="/">
            <img src={require('../assets/FH_Logo-on-LG-Green.png')} alt="Forage Hill Cafe" className="catering-logo" />
          </Link>
          <h2>Catering Menu</h2>
          <p className="catering-info">24 hour notice for cancellation required</p>
          <p className="catering-info">Min order - 6 people</p>
        </div>
        <div className="catering-sections">
          {/* Column 1 */}
          <div className="menu-column">
            <div className="menu-section">
              <h2>Cold Cabinet</h2>
              <div className="menu-items">
                {Object.entries(cateringMenu.coldCabinet).map(([category, items]) => (
                  <div key={category} className="menu-category">
                    <h3>{category.replace(/([A-Z])/g, ' $1').trim()}</h3>
                    {Array.isArray(items) ? items.map((item, index) => (
                      <div key={index} className="menu-item">
                        <span className="menu-item-name">
                          {item.name}
                          {item.min && <span className="min-order"> (min. {item.min})</span>}
                        </span>
                        <span className="menu-item-price">${item.price}</span>
                      </div>
                    )) : (
                      <div className="menu-item">
                        <span className="menu-item-name">{items.name}</span>
                        <span className="menu-item-price">${items.price}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Column 2 */}
          <div className="menu-column">
            <div className="menu-section">
              <h2>Sweets</h2>
              <div className="menu-items">
                {Object.entries(cateringMenu.sweets).map(([category, items]) => (
                  <div key={category} className="menu-category">
                    <h3>{category.replace(/([A-Z])/g, ' $1').trim()}</h3>
                    {Array.isArray(items) ? items.map((item, index) => (
                      <div key={index} className="menu-item">
                        <span className="menu-item-name">
                          {item.name}
                          {item.flavors && (
                            <span className="flavors">
                              Available in: {item.flavors.join(', ')}
                            </span>
                          )}
                        </span>
                        <span className="menu-item-price">${item.price}</span>
                      </div>
                    )) : (
                      <div className="menu-item">
                        <span className="menu-item-name">{category}</span>
                        <span className="menu-item-price">${items}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Column 3 */}
          <div className="menu-column">
            <div className="menu-section">
              <h2>Hot Savoury & Extras</h2>
              <div className="menu-items">
                {Object.entries(cateringMenu.hotSavoury).map(([category, items]) => (
                  <div key={category} className="menu-category">
                    <h3>{category.replace(/([A-Z])/g, ' $1').trim()}</h3>
                    {items.map((item, index) => (
                      <div key={index} className="menu-item">
                        <span className="menu-item-name">{item.name}</span>
                        <span className="menu-item-price">${item.price}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div style={{ marginTop: '2rem' }}>
                <div className="menu-items">
                  {Object.entries(cateringMenu.extras).map(([name, price]) => (
                    <div key={name} className="menu-item">
                      <span className="menu-item-name">{name.replace(/([A-Z])/g, ' $1').trim()}</span>
                      <span className="menu-item-price">${price}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-break"></div>

        <div className="catering-sections">
          {/* Column 1 */}
          <div className="menu-column">
            <div className="menu-section">
              <h2>Platters</h2>
              <div className="platter-items">
                {Object.entries(cateringMenu.platters).slice(0, 6).map(([name, prices]) => {
                  // Custom capitalization for specific items
                  const getFormattedName = (name) => {
                    const specialCases = {
                      'clubSandwich': 'Club Sandwich',
                      'fruitPlatter': 'Fruit Platter',
                      'miniSlices': 'Mini Slices',
                      'miniMuffinScones': 'Mini Muffin/Scones',
                      'miniBurger': 'Mini Burger',
                      'baoBun': 'Bao Bun',
                      'cheesePlatter': 'Cheese Platter',
                      'hotSavoury': 'Hot Savoury'
                    };
                    return specialCases[name] || name.replace(/([A-Z])/g, ' $1').trim();
                  };

                  const getPiecesInfo = (name, size) => {
                    const piecesInfo = {
                      'clubSandwich': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'sushi': { small: '15pcs', medium: '30pcs', large: '50pcs' },
                      'miniSlices': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'miniMuffinScones': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'miniBurger': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'baoBun': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'sliders': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'hotSavoury': { medium: '20pcs', large: '40pcs' }
                    };
                    return piecesInfo[name] ? piecesInfo[name][size] : '';
                  };

                  return (
                    <div key={name} className="platter-item">
                      <h3>{getFormattedName(name)}</h3>
                      {name === 'hotSavoury' && (
                        <div className="platter-description">(mini pie, quiche, sausage roll)</div>
                      )}
                      <div className="platter-prices">
                        {Object.entries(prices).map(([size, price]) => (
                          <div key={size} className="platter-price">
                            {`${size.charAt(0).toUpperCase() + size.slice(1)}${getPiecesInfo(name, size) ? ` (${getPiecesInfo(name, size)})` : ''}: $${price}`}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Column 2 */}
          <div className="menu-column">
            <div className="menu-section">
              <h2>More Platters</h2>
              <div className="platter-items">
                {Object.entries(cateringMenu.platters).slice(6).map(([name, prices]) => {
                  // Custom capitalization for specific items
                  const getFormattedName = (name) => {
                    const specialCases = {
                      'clubSandwich': 'Club Sandwich',
                      'fruitPlatter': 'Fruit Platter',
                      'miniSlices': 'Mini Slices',
                      'miniMuffinScones': 'Mini Muffin/Scones',
                      'miniBurger': 'Mini Burger',
                      'baoBun': 'Bao Bun',
                      'cheesePlatter': 'Cheese Platter',
                      'hotSavoury': 'Hot Savoury'
                    };
                    return specialCases[name] || name.replace(/([A-Z])/g, ' $1').trim();
                  };

                  const getPiecesInfo = (name, size) => {
                    const piecesInfo = {
                      'clubSandwich': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'sushi': { small: '15pcs', medium: '30pcs', large: '50pcs' },
                      'miniSlices': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'miniMuffinScones': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'miniBurger': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'baoBun': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'sliders': { small: '12pcs', medium: '24pcs', large: '36pcs' },
                      'hotSavoury': { medium: '20pcs', large: '40pcs' }
                    };
                    return piecesInfo[name] ? piecesInfo[name][size] : '';
                  };

                  return (
                    <div key={name} className="platter-item">
                      <h3>{getFormattedName(name)}</h3>
                      {name === 'hotSavoury' && (
                        <div className="platter-description">(mini pie, quiche, sausage roll)</div>
                      )}
                      <div className="platter-prices">
                        {Object.entries(prices).map(([size, price]) => (
                          <div key={size} className="platter-price">
                            {`${size.charAt(0).toUpperCase() + size.slice(1)}${getPiecesInfo(name, size) ? ` (${getPiecesInfo(name, size)})` : ''}: $${price}`}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Column 3 */}
          <div className="menu-column">
            <div className="menu-section">
              <h2>Breakfast & Lunch Box</h2>
              <div className="menu-item">
                <span className="menu-item-name">Breakfast Box (min 6 order)</span>
              </div>
              <div className="menu-item-options">
                <div className="menu-item-option">• Scone/muffin + large coffee $11.5</div>
                <div className="menu-item-option">• Sone/muffin + sausage roll + large coffee $17</div>
                <div className="menu-item-option">• Bacon & Egg / Egg & Hash muffin + large coffee $14</div>
                <div className="menu-item-option">• Breakfast wrap + large coffee $15.5</div>
              </div>

              <div className="menu-item" style={{ marginTop: '1.5rem' }}>
                <span className="menu-item-name">Lunch Box (min 6 order)</span>
              </div>
              <div className="menu-item-options">
                <div className="menu-item-option">• Pie + fruit pot $13</div>
                <div className="menu-item-option">• Beef lasagne/chicken mushroom filo/vegetarian roll + salad + sweet $18</div>
                <div className="menu-item-option">• Wrap + fruit pot + sweet $21</div>
                <div className="menu-item-option">• Panini + fruit pot $16.5</div>
                <div className="menu-item-option">• Beef Salad + sweet $18</div>
                <div className="menu-item-option">• Beef lemon grass on rice + sweet $23</div>
                <div className="menu-item-option">• Sweet chilli chicken on rice + fruit pot $23</div>
                <div className="menu-item-option">• Stir fried beef with black pepper on rice + sweet $23</div>
                <div className="menu-item-option">• Spring roll noodle salad + sweet $19</div>
                <div className="menu-item-option">• Vegetarian fried noodle + sweet $22</div>
              </div>

              <div className="box-note">
                Note: For breakfast & lunch box- all muffin/scones and sweets are standard size (not mini ones)
              </div>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <div>Forage Hill Cafe</div>
          <div>87a Mclaughlins Road, Wiri, 2104</div>
          <div>09 217 2768</div>
          <div>foragehill@gmail.com</div>
        </div>
      </div>
    </div>
  );
};

export default Catering;
